import { State } from '../../types'

export const getRoomIds = (state: State) => {
  return state.RoomListContainer
}
